const localStorageAvailable = (): boolean =>
  typeof window === 'object' && typeof Storage === 'function';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setItem = (name: string, value: any, json = true) => {
  if (!localStorageAvailable()) return undefined;

  try {
    window.localStorage.setItem(name, json ? JSON.stringify(value) : value);
  } catch (e) {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  return true;
};
export const getItem = (name: string) => {
  if (!localStorageAvailable()) return undefined;
  let item;

  try {
    item = window.localStorage.getItem(name);
  } catch (e) {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  try {
    return JSON.parse(item);
  } catch {
    return item;
  }
};
export const removeItem = (name: string): boolean | null | undefined => {
  if (!localStorageAvailable()) return undefined;

  try {
    window.localStorage.removeItem(name);
  } catch (e) {
    // swallowing the "this operation is insecure" error from Safari w/ cookies disabled
    return undefined;
  }

  return true;
};
